export const systemFolderId = {
  SiteFiles: 'media-root',
  Mobile: 'mobile-uploads',
  Purchased: 'purchased-items',
  VisitorUploads: 'visitor-uploads',
  WixSite: 'wix-sites',
  Trash: 'trash-root',
  FreeFromWix: 'photos'
};